/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Fact_Energy_ClassInputs */

const cs_public_site_fact_energy_class = /** @type {(inputs: Public_Site_Fact_Energy_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Energetická třída`)
};

const en_public_site_fact_energy_class = /** @type {(inputs: Public_Site_Fact_Energy_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Energy class`)
};

/**
* | output |
* | --- |
* | "Energy class" |
*
* @param {Public_Site_Fact_Energy_ClassInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_fact_energy_class = /** @type {((inputs?: Public_Site_Fact_Energy_ClassInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Fact_Energy_ClassInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_fact_energy_class(inputs)
	return cs_public_site_fact_energy_class(inputs)
});